const projects = [
  {
    id: 1,
    title: "GeekGrid",
    img: "/imgs/projects/geekgrid.jpeg",
    desc: "An Educational website where we can read articles, watch tutorials and apply to jobs.",
    technologies: ["React.js", "Firebase"],
    github: "https://github.com/ashish12501/GeekGrid",
    live: "https://geek-grid.web.app/",
  },
  {
    id: 1,
    title: "EcoScoot",
    img: "/imgs/projects/EcoScoot.png",
    desc: "An EV rental website where users can rent an electric bike of their choice.",
    technologies: ["React.js", "Firebase"],
    github: "https://github.com/ashish12501/EcoScoot",
    live: "https://eco-scoot.web.app/",
  },
  {
    id: 2,
    title: "ExpenseExpert",
    img: "/imgs/projects/ExpenseXpert.png",
    desc: "A web app where you can add, view, edit, delete and track your expenses.",
    technologies: ["React JS", "Firebase"],
    github: "https://github.com/ashish12501/ExpensXpert",
    live: "https://expensxpert.web.app/",
  },
  {
    id: 3,
    title: "Portfolio",
    img: "/imgs/projects/ss.png",
    desc: "A portfolio representing all the Skills , Projects and Blogs created.",
    technologies: ["React.js"],
    github: "https://github.com/ashish12501/Portfolio",
    live: "https://ashish-webdev.web.app/",
  },
  {
    id: 4,
    title: " Vector Class",
    img: "/imgs/projects/Vector.png",
    desc: "An educational website wehere students can read articles and join communities.",
    technologies: ["HTML", "CSS", "Javascript"],
    github: "https://github.com/Vector-Classroom/Vector-Classroom",
    live: "https://vector-classroom.github.io/Vector-Classroom/",
  },

  {
    id: 5,
    title: "To-Do-App",
    img: "/imgs/projects/To-Do-App.png",
    desc: "A To-Do-App where users can add new task, mark them complete, and delete the tasks.",
    technologies: ["React.js"],
    github: "https://github.com/ashish12501/React-ToDo-App",
    live: "https://ashish12501.github.io/React-ToDo-App/",
  },
  {
    id: 6,
    title: "Shopzy",
    img: "/imgs/projects/Shopzy.png",
    desc: "A shoppoiong app where users can browse multiple categories and view products.",
    technologies: ["HTML", "CSS", "Javascript"],
    github: "https://github.com/ashish12501/Shopzy",
    live: "https://ashish12501.github.io/Shopzy/",
  },
  {
    id: 7,
    title: "Socio",
    img: "/imgs/projects/Socio.png",
    desc: "A Social media where usere is able to signin, create posts and view posts of other users.",
    technologies: ["React.js", "Firebase"],
    github: "https://github.com/ashish12501/Socio-TheSocialMedia",
    live: "https://codwiz.vercel.app/",
  },
];

const skills = [
  {
    icon: "html",
    title: "HTML",
  },
  {
    icon: "css",
    title: "CSS",
  },
  {
    icon: "javascript",
    title: "JavaScript",
  },
  {
    icon: "typescript",
    title: "TypeScript",
  },
  {
    icon: "react",
    title: "React.js",
  },
  {
    icon: "react",
    title: "React Native",
  },
  {
    icon: "redux",
    title: "Redux Toolkit",
  },
  // {
  //   icon: "nextjs",
  //   title: "Next.js",
  // },
  {
    icon: "tailwind",
    title: "Tailwind CSS",
  },
  {
    icon: "nativeWind",
    title: "NativeWind",
  },
  {
    icon: "nodejs",
    title: "Node.js",
  },
  {
    icon: "express",
    title: "Express.js",
  },
  {
    icon: "firebase",
    title: "Firebase",
  },
  {
    icon: "mysql",
    title: "MySQL",
  },
  {
    icon: "git",
    title: "Git",
  },
  {
    icon: "figma",
    title: "Figma",
  },
  {
    icon: "github",
    title: "Github",
  },
];

export const data = { projects, skills };
